import React, { useState } from 'react'
import { Button, Collapse } from '@paintscout/ui'
import classNames from 'classnames'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import CreateIcon from '@material-ui/icons/Create'
import ApprovedAdditionalWorkActions from './ApprovedAdditionalWorkActions'
import ApprovedAdditionalWorkRow from './ApprovedAdditionalWorkRow'
import PendingAdditionalWorkActions from './PendingAdditionalWorkActions'
import type { PainterAdditionalWork } from './types'
import { handleKeyboardAction } from './keyboard'
import type { usePainterAdditionalWorkStyles } from './usePainterAdditionalWorkStyles'
import striptags from 'striptags'

interface AdditionalWorkItemProps {
  item: PainterAdditionalWork
  showHours?: boolean
  classes: ReturnType<typeof usePainterAdditionalWorkStyles>
  onAcceptSign?: (id: string) => void
  onEdit?: (id: string) => void
  onDelete?: (id: string) => void
  onViewMedia?: (id: string) => void
}

export default function AdditionalWorkItem(props: AdditionalWorkItemProps) {
  const { item, showHours = true, classes, onAcceptSign, onEdit, onDelete, onViewMedia } = props
  const [expanded, setExpanded] = useState(false)
  const valueLabel = showHours && item.hours != null && item.hours > 0 ? `${item.hours} hr` : undefined
  const isApproved = item.status === 'approved'
  const hideExpand = isApproved && !item.media?.length && (!item.description || !striptags(item.description).trim())
  return (
    <>
      <div
        className={classNames(classes.summaryRow, {
          [classes.summaryRowExpanded]: expanded,
          [classes.summaryRowCollapsed]: !expanded
        })}
        onClick={() => (hideExpand ? null : setExpanded((v) => !v))}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => handleKeyboardAction(event, () => setExpanded((v) => !v))}
      >
        <div className={classes.summaryRowHeader}>
          <span className={classes.summaryRowLabel}>{item.name}</span>
          <div className={classes.summaryRowValue}>
            {valueLabel && <span className={classes.summaryRowValueText}>{valueLabel}</span>}
            {!hideExpand && (
              <>
                {expanded ? (
                  <KeyboardArrowUpIcon className={classes.summaryRowIcon} />
                ) : (
                  <KeyboardArrowDownIcon className={classes.summaryRowIcon} />
                )}
              </>
            )}
          </div>
        </div>
        {isApproved && <ApprovedAdditionalWorkRow item={item} classes={classes} collapsed={!expanded} />}
      </div>
      <Collapse show={expanded}>
        <div className={classes.awItemContent}>
          {!isApproved && (
            <div className={classes.acceptSignRow}>
              <Button className={classes.acceptSignBtn} onClick={() => onAcceptSign?.(item.id)} icon={CreateIcon}>
                Accept &amp; Sign
              </Button>
            </div>
          )}
          {item.description && !!striptags(item.description) && (
            <div className={classes.awDescription} dangerouslySetInnerHTML={{ __html: item.description }} />
          )}
          {isApproved ? (
            <ApprovedAdditionalWorkActions item={item} classes={classes} onViewMedia={onViewMedia} />
          ) : (
            <PendingAdditionalWorkActions
              item={item}
              classes={classes}
              onViewMedia={onViewMedia}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          )}
        </div>
      </Collapse>
    </>
  )
}
